var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":_vm.title},on:{"close":function($event){return _vm.$emit('close')}}},[(_vm.type == 'privacy')?_c('NovakidPrivacyContent'):_vm._e(),(_vm.type == 'terms')?_c('NovakidTermsContent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }